import request from '@wearetla/tla-essentials-tools/utilities/request';
import config from '/config';

const siteServices = {
	checkAppUpdates: () => {
		return new Promise((resolve, reject) => {
			request.get(
				'get-build-number',
				false,
				(payload) => {
					if (payload?.length) {
						resolve(config.buildNumber !== payload);
					} else {
						reject(payload);
					}
				},
				{ static: true, external: true }
			);
		});
	},
	getBanners: (branchId) => {
		return new Promise((resolve, reject) => {
			request.get(
				`client/${config.clientId}/branch/${branchId}/banners`,
				{},
				(payload, status, request) => {
					if (payload?.client_branch_banners?.length) {
						resolve(payload.client_branch_banners);
					} else {
						reject(
							request?.data?.meta?.messages || 'Bannerlar getirilirken bir hata ile karşılaşıldı.'
						);
					}
				}
			);
		});
	},
	getCategories: () => {
		return new Promise((resolve, reject) => {
			request.get(
				`dummy/api/home-categories.json`,
				{},
				(payload, status, request) => {
					if (payload?.categories?.length) {
						resolve(payload.categories);
					} else {
						reject(
							request?.data?.meta?.messages || 'Kategoriler getirilirken bir hata ile karşılaşıldı.'
						);
					}
				},
				{ static: true }
			);
		});
	},
	getHighlightedProducts: () => {
		return new Promise((resolve, reject) => {
			request.get(
				`dummy/api/home-highlighted-products.json`,
				{},
				(payload, status, request) => {
					if (payload?.products?.length) {
						resolve(payload.products);
					} else {
						reject(
							request?.data?.meta?.messages || 'Ürünler getirilirken bir hata ile karşılaşıldı.'
						);
					}
				},
				{ static: true }
			);
		});
	},
	getCampaigns: () => {
		return new Promise((resolve, reject) => {
			request.get(
				`dummy/api/campaigns.json`,
				{},
				(payload, status, request) => {
					if (payload?.campaigns) {
						resolve(payload.campaigns);
					} else {
						reject(
							request?.data?.meta?.messages || 'Ürünler getirilirken bir hata ile karşılaşıldı.'
						);
					}
				},
				{ static: true }
			);
		});
	},
	getAnnouncements: () => {
		return new Promise((resolve, reject) => {
			request.get(
				`dummy/api/announcements.json`,
				{},
				(payload, status, request) => {
					if (payload?.announcements) {
						resolve(payload.announcements);
					} else {
						reject(
							request?.data?.meta?.messages || 'Ürünler getirilirken bir hata ile karşılaşıldı.'
						);
					}
				},
				{ static: true }
			);
		});
	},
};

export default siteServices;
